import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NamedLink } from '../../components';
import { Link } from '../PageBuilder/Primitives/Link';

const Feature = ({ title, text, ctaText, ctaLink, isReversed }) => {
  return (
    <div className={`flex flex-col lg:flex-row items-center  ${isReversed ? 'lg:flex-row-reverse' : ''}`}>
      {/* Content */}
      <div className={`flex-1 rounded-lg lg:max-w-1/2 text-left p-6 px-10`}>
        <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-6 font-['Be_Vietnam_Pro']">
          {title}
        </h3>
        <p className="text-lg text-gray-700 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
          {text}
        </p>
        <a className="inline-block bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors duration-200">
        <Link
          href={ctaLink}
        >
          {ctaText}
        </Link>
        </a>
      </div>
      
      {/* Visual Element */}
      <div className='hidden lg:block w-1/2 bg-gray-100 p-6 rounded-lg min-h-[400px]'>
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        
        
        
        {/* Features */}
        <div className="space-y-8 lg:space-y-8">
          
          {/* Feature 1 - Our Vision */}
          <Feature
            title={<FormattedMessage id="LandingPage.features.ourVision.title" />}
            text={<FormattedMessage id="LandingPage.features.ourVision.text" />}
            ctaText={<FormattedMessage id="LandingPage.features.ourVision.cta" />}
            ctaLink="/join-us"
            isReversed={false}
          />
          
          {/* Feature 2 - Join Community */}
          <Feature
            title={<FormattedMessage id="LandingPage.features.browseArtwork.title" />}
            text={<FormattedMessage id="LandingPage.features.browseArtwork.text" />}
            ctaText={<FormattedMessage id="LandingPage.features.browseArtwork.cta" />}
            ctaLink="/s"
            isReversed={true}
          />
          
        </div>
        
      </div>
    </section>
  );
};

export default FeaturesSection; 